@if (routerLink()) {
<a class="footer-link" [routerLink]="routerLink()">
  <ng-container *ngTemplateOutlet="linkContent" />
</a>
} @else {
<a
  class="footer-link"
  [href]="href()"
  [attr.target]="openInNewTab() ? '_blank' : null"
  [attr.rel]="openInNewTab() ? 'noopener noreferrer' : null"
>
  <ng-container *ngTemplateOutlet="linkContent" />
</a>
}

<ng-template #linkContent>
  <gc-text textColor="invert">
    <ng-content />
    @if (isPdfDocument()) {
    <span class="visually-hidden">{{ 'footer.pdfDocument' | translate }}</span>
    } @if (openInNewTab()) {
    <span class="visually-hidden">{{ 'footer.newTab' | translate }}</span>
    }
  </gc-text>
</ng-template>
